import dayjs from 'dayjs'

import type { DateRange } from '@/shared/ui/components'

export const DATE_FORMAT_CLIENT = 'YYYY/MM/DD'
const DATE_FORMAT_SERVER = 'YYYY-MM-DDTHH:mm:ss.SSSZ'

const toServerDateFormatStart = (value: string) =>
  dayjs(value, DATE_FORMAT_CLIENT).startOf('day').format(DATE_FORMAT_SERVER)

const toServerDateFormatEnd = (value: string) =>
  dayjs(value, DATE_FORMAT_CLIENT).endOf('day').format(DATE_FORMAT_SERVER)

export interface UseDateRangeOptions {
  /** Начальный диапазон не задан (оба поля null) вместо «текущий месяц — сегодня» */
  initialUnset?: boolean
  /** Внешнее хранилище диапазона (например, синк с URL query params); `initialUnset` при этом игнорируется */
  dateRange?: Ref<DateRange>
}

export function useDateRange(options: UseDateRangeOptions = {}) {
  const dateFormat = DATE_FORMAT_CLIENT
  const dateStartOfMonth = dayjs().startOf('month').format(dateFormat)
  const dateCurrent = dayjs().endOf('day').format(dateFormat)
  const dateRange =
    options.dateRange ??
    ref<DateRange>(options.initialUnset ? { from: null, to: null } : { from: dateStartOfMonth, to: dateCurrent })

  const getServerDateFormatFrom = () => {
    return dateRange.value.from ? toServerDateFormatStart(dateRange.value.from) : null
  }

  const getServerDateFormatTo = () => {
    return dateRange.value.to ? toServerDateFormatEnd(dateRange.value.to) : null
  }

  return {
    dateFormat,
    dateRange,

    getServerDateFormatFrom,
    getServerDateFormatTo,
  }
}
